import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { homeBreadcrumbItem, useBreadcrumbsService } from 'shared/UI/UIKit/Breadcrumbs';
import { getConfigurationSchedulesUrl, getScheduleForWeekUrl } from 'services/navigation';
import { getScheduleConfigurationById } from 'services/api';
import type { SchedulePageParams } from 'services/navigation';

const getScheduleBreadcrumbs = (configurationName: string, configurationId: string) => {
  return [
    homeBreadcrumbItem,
    {
      title: 'Расписание на неделю',
      url: getScheduleForWeekUrl(),
    },
    {
      title: configurationName,
      url: getConfigurationSchedulesUrl({ configurationId }),
    },
    {
      title: 'Расписание',
      url: '',
    },
  ];
};

export const useSchedulePage = () => {
  const { configurationId } = useParams<SchedulePageParams>();
  const breadcrumbsService = useBreadcrumbsService();

  useEffect(() => {
    if (configurationId) {
      breadcrumbsService.setBreadcrumbsLoading(true);

      getScheduleConfigurationById(Number(configurationId))
        .then((res) => {
          breadcrumbsService.setBreadcrumbs(getScheduleBreadcrumbs(res.name, configurationId));
        })
        .finally(() => {
          breadcrumbsService.setBreadcrumbsLoading(false);
        });
    }
  }, [configurationId]);

  return {
    breadcrumbs: breadcrumbsService.breadcrumbs,
    breadcrumbsLoading: breadcrumbsService.breadcrumbsLoading,
  };
};
